export const DRAWER_WIDTH = '15%'
